/**
 * jQuery has to be on `window` before any jQuery plugin module is evaluated,
 * so it gets its own module — imports are evaluated in the order they appear.
 */
import jQuery from 'jquery';

window.$ = jQuery;
window.jQuery = jQuery;
